<template lang='pug'>
  .index-breadcrumbs-container.js-breadcrumbs
    ol.breadcrumb(v-if='entityLoaded')
      li.breadcrumb-item(:class='{ "active": index === breadcrumbs.length - 1 }' v-for='(breadcrumb, index) in breadcrumbs')
        //- The if can be removed once Home is fully loaded within the SPA
        template(v-if='typeof(breadcrumb.path) === "object"')
          router-link.breadcrumb-text(:to='breadcrumb.path' v-text='breadcrumb.label')
        template(v-else)
          a.breadcrumb-text(:href='breadcrumb.path' v-text='breadcrumb.label')
</template>

<script>
import { mapState, mapGetters } from 'vuex'

export default {
  computed: {
    ...mapState({
      entity: state => state.product.entity,
      entitySlug: state => state.product.entitySlug,
      entityType: state => state.product.entityType,
      entityLoaded: state => state.product.entityLoaded,
      categories: state => state.category.categories
    }),
    ...mapGetters([
      'entityPath',
      'activeCategory',
      'parentIdsForCategory'
    ]),
    isMobile: () => vueSupport.isMobile,
    breadcrumbs () {
      const breadcrumbs = [
        { path: '/', label: 'Home' }
      ]

      if (this.entityType !== 'categories') {
        if (this.entityType === 'search') {
          breadcrumbs.push({ path: this.entityPath(), label: this.entitySlug })
        } else {
          breadcrumbs.push({ path: this.entityPath(), label: this.entity.attributes['label'] || this.entity.attributes['name'] || this.entity.attributes['title'] || this.entity.attributes['code'] })
        }
      }

      if (this.activeCategory.attributes) {
        const parentsId = this.parentIdsForCategory(this.activeCategory).split('/').reverse()
        parentsId.forEach(parent => {
          const category = this.categories.find(category => category.id === parent)
          breadcrumbs.push({ path: this.entityPath(category.attributes['slug-url']), label: category.attributes['label'] })
        })
      }

      return breadcrumbs
    }
  }
}
</script>

<style scoped lang='scss'>
  .index-breadcrumbs-container {
    margin-bottom: 5px;
  }

  .active {
    pointer-events: none;
  }

  .breadcrumb-text {
    text-decoration: inherit;

    &:hover {
      color: inherit;
    }
  }
</style>
